import { gql } from '@apollo/client';

export const GET_BRANDS = gql`
  query listBrands {
    listBrands {
      id
      name
      previousName
      website
      address
      state
      country
      phoneNumber
      parent {
        id
      }
    }
  }
`;

export const GET_BRAND_BY_ID = gql`
  query brand($id: String!) {
    brand(id: $id) {
      id
      name
      previousName
      website
      address
      state
      country
      phoneNumber
      parent {
        id
      }
    }
  }
`;

export const LIST_BRANDS_WITH_CHILDREN = gql`
  query brandsWithChildren {
    brandsWithChildren {
      id
      name
      previousName
      website
      address
      state
      country
      phoneNumber
      parent {
        id
      }
      children {
        id
        name
        previousName
        website
        address
        state
        country
        phoneNumber
      }
    }
  }
`;

export const ADD_BRAND = gql`
  mutation createBrand(
    $name: String!
    $previousName: String
    $website: String
    $address: String
    $state: String
    $country: String
    $phoneNumber: String
    $parent: String
  ) {
    createBrand(
      input: {
        name: $name
        previousName: $previousName
        website: $website
        address: $address
        state: $state
        country: $country
        phoneNumber: $phoneNumber
        parent: $parent
      }
    ) {
      id
      name
      previousName
      website
      address
      state
      country
      phoneNumber
    }
  }
`;

export const EDIT_BRAND = gql`
  mutation updateBrand(
    $id: String!
    $name: String!
    $previousName: String
    $website: String
    $address: String
    $state: String
    $country: String
    $phoneNumber: String
    $parent: String
  ) {
    updateBrand(
      id: $id
      input: {
        name: $name
        previousName: $previousName
        website: $website
        address: $address
        state: $state
        country: $country
        phoneNumber: $phoneNumber
        parent: $parent
      }
    ) {
      id
      name
      previousName
      website
      address
      state
      country
      phoneNumber
    }
  }
`;

export const DELETE_BRAND = gql`
  mutation deleteBrand($id: String!) {
    deleteBrand(id: $id) {
      id
      name
    }
  }
`;
